import type { GuardianPuzzle } from "./converters/nytToGuardian";

// A simple sample puzzle for testing
export const samplePuzzle: GuardianPuzzle = {
  id: "sample/1",
  number: 1,
  name: "Sample Crossword #1",
  creator: { name: "Test Author", webUrl: "" },
  date: Date.now(),
  dimensions: { rows: 5, cols: 5 },
  crosswordType: "quick",
  solutionAvailable: true,
  entries: [
    {
      id: "1-across",
      number: 1,
      humanNumber: "1",
      clue: "Greeting",
      direction: "across",
      length: 5,
      group: ["1-across"],
      position: { x: 0, y: 0 },
      separatorLocations: {},
      solution: "HELLO",
    },
    {
      id: "4-across",
      number: 4,
      humanNumber: "4",
      clue: "Planet we live on",
      direction: "across",
      length: 5,
      group: ["4-across"],
      position: { x: 0, y: 2 },
      separatorLocations: {},
      solution: "EARTH",
    },
    {
      id: "5-across",
      number: 5,
      humanNumber: "5",
      clue: "Opposite of old",
      direction: "across",
      length: 5,
      group: ["5-across"],
      position: { x: 0, y: 4 },
      separatorLocations: {},
      solution: "YOUNG",
    },
    {
      id: "1-down",
      number: 1,
      humanNumber: "1",
      clue: "Center of the body",
      direction: "down",
      length: 5,
      group: ["1-down"],
      position: { x: 0, y: 0 },
      separatorLocations: {},
      solution: "HEART",
    },
    {
      id: "2-down",
      number: 2,
      humanNumber: "2",
      clue: "Not late",
      direction: "down",
      length: 5,
      group: ["2-down"],
      position: { x: 2, y: 0 },
      separatorLocations: {},
      solution: "EARLY",
    },
    {
      id: "3-down",
      number: 3,
      humanNumber: "3",
      clue: "Where the sun rises",
      direction: "down",
      length: 5,
      group: ["3-down"],
      position: { x: 4, y: 0 },
      separatorLocations: {},
      solution: "OTAGO",
    },
  ],
};

// Function to create puzzle data for Convex
export function createPuzzleRecord(puzzle: GuardianPuzzle) {
  return {
    sourceId: puzzle.id,
    source: puzzle.id.split("/")[0],
    title: puzzle.name,
    author: puzzle.creator?.name,
    date: puzzle.date,
    dimensions: puzzle.dimensions || { rows: 15, cols: 15 },
    data: puzzle,
  };
}
